import { H1 } from '@atoms/Typographies';
import { useCloseRequest } from '@hooks/Services';
import { Container, ContainerForFacility } from '@organisms/GenesisEs/Layouts';
import {
    DetailApplicationInfoClose,
    DetailMemoListClose,
    DetailTransmissionResultClose
} from '@organisms/GenesisEs/List';
import Head from '@organisms/Heads/Head';
import { Page404 } from '@pages/index';
import CommonTemplate from '@templates/Common';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

const Detail = () => {
    const id: any = useParams().id;
    const listData = useCloseRequest.useAllListData(id);
    const { data } = listData;
    if (!data) {
        return <Page404 />
    }
    const number = data.powerCustomerLocationNumber;

    return (
        <CommonTemplate>
            <Head title="廃止申込結果詳細" />
            <HeadingWithStyled className="mb-4">
                <H1>廃止申込結果詳細</H1>
            </HeadingWithStyled>

            <Container
                title='申込情報'
                children={<DetailApplicationInfoClose listData={listData} />}
            />
            <Container
                title='送信結果'
                children={<DetailTransmissionResultClose />}
            />
            <ContainerForFacility
                powerCustomerLocationNumber={number}
            />
            <Container
                title='Memo'
                children={<DetailMemoListClose />}
            />

        </CommonTemplate>
    );
};

const HeadingWithStyled = styled.div`
`

export default Detail;
